import { Navigate, Outlet } from 'react-router-dom';

// Route guard for the pages that have NO platform permission in the catalogue
// and so stay the Super Admin's alone — Settings (platform feature flags,
// payment holds). Everything else in this portal opens by permission through
// PlatformPermissionRoute, which the Super Admin also passes. Role is
// normalised to 'admin' for both admin and super_admin, so this keys on the
// isSuperAdmin flag set at login; a platform staff member (or a plain admin)
// who deep-links here bounces to "/", which resolves to their own first page.
export default function SuperAdminRoute() {
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';
  if (!isSuperAdmin) {
    return <Navigate to="/" replace data-testid="super-admin-route-redirect" />;
  }
  return <Outlet />;
}
